import styled from '@emotion/styled';
import { Tooltip } from '@kc-console/common-ui';
import { env } from '@kc-console/context';
import IcUserguideRegular from '@kep/kcds-icons/IcUserguideRegular';

import { GnbIconButton } from './GnbIconButton';

export default function GnbGuideLink() {
  return (
    <Tooltip message={'기술 문서로 이동합니다.'}>
      <GuideMenuLinkContainer
        href={`${env.KC_DOCS_URL}/ko/start`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <GnbIconButton disableRipple tabIndex={-1}>
          <IcUserguideRegular />
        </GnbIconButton>
      </GuideMenuLinkContainer>
    </Tooltip>
  );
}

const GuideMenuLinkContainer = styled('a')(({ theme }) => ({
  position: 'relative',
  ...theme.mixins.focusRing('inside', { inverse: true }),
}));
